import { render, staticRenderFns } from "./HeaderSoftware.vue?vue&type=template&id=c02de472&"
import script from "./HeaderSoftware.vue?vue&type=script&lang=js&"
export * from "./HeaderSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports